
import { Component, OnDestroy, OnInit,AfterViewInit, Input, SimpleChanges, ElementRef, OnChanges,  ViewChild, EventEmitter, Output } from '@angular/core';
/*tslint:enable:max-line-length */
import { FlightHoursService } from '../../../services/flight-hours.service';
import { COCalcView } from '../../../models/COCalcView';
import { Code } from '../../../models/Code';
import { ContractService } from '../../../services/contract.service';

@Component({
  selector: 'app-co2-offset',
  templateUrl: './co2-offset.component.html',
  styleUrls: ['./co2-offset.component.scss']
})
export class Co2OffsetComponent implements OnInit, AfterViewInit {
   public co2calcview: COCalcView;
   public alive = true;
   public ACTypeList: Code[];
   public ACMakelist: Code[];
   public ACModelList: Code[];
   public index: number;
   public triptime: number;
   public EmissionPerHR: number;
   public EmissionPerTrip: number;
   public EmissionPerSeat: number;
   public EmissionPerYear: number;
   public co2crdPerHR: number;
   public co2crdPerTrip: number;
   public co2crdPerSeat: number;
   public co2crdPerYear: number;
   public calculateflag: boolean;
   public weighttonne: number;
   public SustainabilityUrl: string;

   constructor(private _flightHoursService: FlightHoursService,
    private contractsvc: ContractService
    ) { }

  ngOnInit() {
    this.calculateflag = true;
     this.getco2calcInfo('10190');

    this.getACtypeList();

    this.getCDDMakeList('JETS');
    this.getCDDModelList('JETS', '36');
    this.co2calcview.ACNum = '10190';
    this.co2calcview.ACMfgNum = '36';



  }

  async ngAfterViewInit() {
    this.SustainabilityUrl = await this.contractsvc.getConfig('SustainabilityUrl');
    console.log(this.SustainabilityUrl + 'sustainbilityurl');
  }
   getACtypeList() {
     this.index = 0;
     this.ACTypeList = new Array<Code>();
    this.ACTypeList[this.index] = new Code();
    this.ACTypeList[this.index].ID = 'JETS';
    this.ACTypeList[this.index++].Name = 'JETS';
    this.ACTypeList[this.index] = new Code();
    this.ACTypeList[this.index].ID = 'TURBOPROPS';
    this.ACTypeList[this.index++].Name = 'TURBOPROPS';
    this.ACTypeList[this.index] = new Code();
    this.ACTypeList[this.index].ID = 'HELICOPTERS';
    this.ACTypeList[this.index++].Name = 'HELICOPTERS';
    this.ACTypeList[this.index] = new Code();
    this.ACTypeList[this.index].ID = 'PISTONS';
    this.ACTypeList[this.index++].Name = 'PISTONS';





   }
   getACMakeList() {
    this.index = 0;
    this.ACMakelist = new Array<Code>();
   this.ACMakelist[this.index] = new Code();
   this.ACMakelist[this.index].ID = 'TEST1';
   this.ACMakelist[this.index++].Name = 'TEST1';
   this.ACMakelist[this.index] = new Code();
   this.ACMakelist[this.index].ID = 'TURBOPROPS';
   this.ACMakelist[this.index++].Name = 'TURBOPROPS';
   this.ACMakelist[this.index] = new Code();
   this.ACMakelist[this.index].ID = 'HELICOPTERS';
   this.ACMakelist[this.index++].Name = 'HELICOPTERS';
   this.ACMakelist[this.index] = new Code();
   this.ACMakelist[this.index].ID = 'PISTONS';
   this.ACMakelist[this.index++].Name = 'PISTONS';
   this.ACMakelist[this.index] = new Code();
   this.ACMakelist[this.index].ID = 'TEST123345678TEST123345678';
   this.ACMakelist[this.index++].Name = 'TEST123345678TEST123345678';





  }

   onChangeACtype(Actype: string) {
     this.ACMakelist =  new Array<Code>();
     this.ACModelList =  new Array<Code>();

    this.getCDDMakeList(Actype);

   }
   onChangeACMake(Actype: string, acmfgNum: string) {
    this.ACModelList = new Array<Code>();
    this.getCDDModelList(Actype, acmfgNum);

   }
   onChangeACModel(AcNum: string) {
    this.calculateflag  = true;
    this.getco2calcInfo(AcNum);


   }
   setcalculateFlag() {
     this.calculateflag = false;
   }
  getco2calcInfo(acNum: string) {
    console.log('co2 acnum' + acNum);
    this.getACtypeList();
    this.co2calcview = null;
    this._flightHoursService.getCo2CalcInfo(acNum)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.co2calcview = data;
         // this.co2calcview.OffsetRate = 12.5;
          this.calculate();
        });


  }

  getCDDMakeList(acType: string) {

    console.log('co2 actype' + acType);
    this._flightHoursService.getCDDMakeList(acType)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.ACMakelist = data;
        });
  }
  getCDDModelList(acType: string, acMfgNum: string) {

    this._flightHoursService.getCDDModelList(acType, acMfgNum)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.ACModelList = data;
        });
  }
  calculate() {
    this.triptime =  this.co2calcview.TripLength  / this.co2calcview.VBlock1 ;

    this.EmissionPerHR = this.co2calcview.FuelBurn * this.co2calcview.CO2LbsGal / 2204 * this.co2calcview.CO2Fuel;
     this.EmissionPerTrip = this.triptime * this.EmissionPerHR  ;
     this.EmissionPerSeat =  this.EmissionPerTrip / this.co2calcview.PassengerSeats ;
    this.EmissionPerYear = this.EmissionPerHR * this.co2calcview.AnnualFlightHours  ;
   // this.co2calcview.OffsetRate = 12.5; // need to confirm this
    this.co2crdPerHR = this.EmissionPerHR * this.co2calcview.OffsetRate;
    this.co2crdPerSeat = this.EmissionPerSeat * this.co2calcview.OffsetRate;
    this.co2crdPerTrip = this.EmissionPerTrip * this.co2calcview.OffsetRate;
    this.co2crdPerYear = this.EmissionPerYear * this.co2calcview.OffsetRate;

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/client/co2-offset/co2-offset.component.ts